export const clampText = (str: string, limit: number, elipsis = '...'): string =>
    str.length > limit ? `${str.substr(0, limit - elipsis.length).trim()}${elipsis}` : str